// src/components/fx/OfferBanner.jsx
// Colourful "90% OFF" banner with live fireworks behind and
// natural-looking burning crackers (flower pot, sparkler, chakkar) on the right. Used at the top of the Products page.

import React from 'react';
import FireworksCanvas from './FireworksCanvas';
import CrackerScene from './CrackerScene';
import { SHOP_NAME } from '../../config/tenant';
import './fx.css';

export default function OfferBanner({ pct }) {
  const [first, ...rest] = SHOP_NAME.split(' ');
  return (
    <section className="ob" aria-label={pct ? `${pct}% off Diwali sale` : 'Diwali sale'}>
      <FireworksCanvas density={1.6} power={1.2} rays speed={0.45} />
      <div className="ob-glow" aria-hidden="true" />

      <div className="ob-copy">
        <span className="ob-chip">🪔 Diwali Mega Sale</span>
        {pct ? (
          <p className="ob-big">
            <span className="ob-num">{pct}%</span>
            <span className="ob-off">OFF</span>
          </p>
        ) : (
          <p className="ob-big"><span className="ob-num ob-num-sm">Mega Offers</span></p>
        )}
        <p className="ob-brand" aria-label={SHOP_NAME}>
          <span className="ob-brand-line" aria-hidden="true" />
          <span className="ob-brand-main">{first}</span>
          {rest.length > 0 && <span className="ob-brand-sub">{rest.join(' ')}</span>}
          <span className="ob-brand-line" aria-hidden="true" />
        </p>
      </div>

      <div className="ob-art">
        <CrackerScene />
      </div>
    </section>
  );
}
